/**
 * @generated SignedSource<<47db7e35132937184cc74885c8333a82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveParticipantFromMyBookingInput = {
  availabilityId: string;
  clientMutationId?: string | null;
  participantId: string;
};
export type appointmentDetails_RemoveParticipantFromMyBookingMutation$variables = {
  input: RemoveParticipantFromMyBookingInput;
};
export type appointmentDetails_RemoveParticipantFromMyBookingMutation$data = {
  readonly Coaching: {
    readonly removeParticipantFromMyBooking: {
      readonly availability: {
        readonly " $fragmentSpreads": FragmentRefs<"appointmentOverviewModal_AvailabilityFragment">;
      };
    } | null;
  };
};
export type appointmentDetails_RemoveParticipantFromMyBookingMutation = {
  response: appointmentDetails_RemoveParticipantFromMyBookingMutation$data;
  variables: appointmentDetails_RemoveParticipantFromMyBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "CoachingOfferDescription",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AcademiesTagData",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "userExtensionKind",
        "value": "Academies"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "extension",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnail",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sumGamificationPoints",
            "storageKey": null
          }
        ],
        "type": "AcademiesUserExtension",
        "abstractKey": null
      }
    ],
    "storageKey": "extension(userExtensionKind:\"Academies\")"
  }
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "participationStatus",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "msTeamsLink",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "appointmentDetails_RemoveParticipantFromMyBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CoachingMutations",
        "kind": "LinkedField",
        "name": "Coaching",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "RemoveParticipantFromMyBookingPayload",
            "kind": "LinkedField",
            "name": "removeParticipantFromMyBooking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Availability",
                "kind": "LinkedField",
                "name": "availability",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "appointmentOverviewModal_AvailabilityFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "appointmentDetails_RemoveParticipantFromMyBookingMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CoachingMutations",
        "kind": "LinkedField",
        "name": "Coaching",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "RemoveParticipantFromMyBookingPayload",
            "kind": "LinkedField",
            "name": "removeParticipantFromMyBooking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Availability",
                "kind": "LinkedField",
                "name": "availability",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "booking",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingOffer",
                            "kind": "LinkedField",
                            "name": "offer",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "setting",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxParticipants",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "GroupCoachingSetting",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "licenseAvailability",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numAvailable",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "LicenseAvailabilityFreeLicensesAvailable",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Participant",
                            "kind": "LinkedField",
                            "name": "participants",
                            "plural": true,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "type": "BookedForGroup",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoachingOffer",
                            "kind": "LinkedField",
                            "name": "offer",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Participant",
                            "kind": "LinkedField",
                            "name": "participant",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "type": "BookedOneToOne",
                        "abstractKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailabilityData",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDateTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDateTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CoachProfile",
                    "kind": "LinkedField",
                    "name": "coachProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "coach",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CoachFeedback",
                    "kind": "LinkedField",
                    "name": "feedback",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachingFeedbackData",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "comment",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "score",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c23aac6b01e6ae26d5bfd9d539674853",
    "id": null,
    "metadata": {},
    "name": "appointmentDetails_RemoveParticipantFromMyBookingMutation",
    "operationKind": "mutation",
    "text": "mutation appointmentDetails_RemoveParticipantFromMyBookingMutation(\n  $input: RemoveParticipantFromMyBookingInput!\n) {\n  Coaching {\n    removeParticipantFromMyBooking(input: $input) {\n      availability {\n        ...appointmentOverviewModal_AvailabilityFragment\n        id\n      }\n    }\n  }\n}\n\nfragment appointmentDetails_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    kind\n    ... on BookedForGroup {\n      offer {\n        description {\n          description\n        }\n        setting {\n          __typename\n          ... on GroupCoachingSetting {\n            maxParticipants\n          }\n        }\n        licenseAvailability {\n          __typename\n          ... on LicenseAvailabilityFreeLicensesAvailable {\n            numAvailable\n          }\n        }\n        id\n      }\n      participants {\n        user {\n          id\n          ...participantPreview_UserFragment\n        }\n      }\n      msTeamsLink\n    }\n    ... on BookedOneToOne {\n      offer {\n        description {\n          description\n        }\n        id\n      }\n      participant {\n        user {\n          id\n          ...participantPreview_UserFragment\n        }\n      }\n      msTeamsLink\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      id\n      ...participantPreview_UserFragment\n    }\n    id\n  }\n}\n\nfragment appointmentOverviewModal_AvailabilityFragment on Availability {\n  id\n  booking {\n    __typename\n    ... on BookedForGroup {\n      offer {\n        description {\n          name\n          tags {\n            __typename\n            id\n            data {\n              name\n            }\n          }\n        }\n        id\n      }\n      participants {\n        participationStatus\n      }\n    }\n    ... on BookedOneToOne {\n      offer {\n        description {\n          name\n          tags {\n            __typename\n            id\n            data {\n              name\n            }\n          }\n        }\n        id\n      }\n      participant {\n        participationStatus\n      }\n    }\n  }\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      id\n    }\n    id\n  }\n  ...appointmentDetails_AvailabilityFragment\n  ...appointmentStatusLabel_AvailabilityFragment\n  ...appointmentRating_AvailabilityFragment\n  ...appointmentPresence_AvailabilityFragment\n}\n\nfragment appointmentPresence_AvailabilityFragment on Availability {\n  id\n  data {\n    startDateTime\n    endDateTime\n  }\n  booking {\n    __typename\n    ... on BookedForGroup {\n      participants {\n        user {\n          id\n        }\n        participationStatus\n        ...participantPresenceCheck_ParticipantFragment\n      }\n    }\n    ... on BookedOneToOne {\n      participant {\n        user {\n          id\n        }\n        participationStatus\n        ...participantPresenceCheck_ParticipantFragment\n      }\n    }\n  }\n}\n\nfragment appointmentRating_AvailabilityFragment on Availability {\n  id\n  data {\n    startDateTime\n    endDateTime\n  }\n  coachProfile {\n    coach {\n      ...participantPreview_UserFragment\n      id\n    }\n    id\n  }\n  feedback {\n    data {\n      comment\n      score\n    }\n    id\n  }\n}\n\nfragment appointmentStatusLabel_AvailabilityFragment on Availability {\n  data {\n    startDateTime\n    endDateTime\n  }\n}\n\nfragment participantPresenceCheck_ParticipantFragment on Participant {\n  user {\n    id\n    name\n    ...userAvatar_UserFragment\n  }\n  participationStatus\n}\n\nfragment participantPreview_UserFragment on User {\n  name\n  ...userAvatar_UserFragment\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "349211534a30462bc36dd14c4d30b3d9";

export default node;
